import Footer from "components/Footer";
import Header from "components/Header";
import MainTitle from "components/MainTitle";
import QuickDonate from "components/QuickDonate/QuickDonate";
import { useSelector } from "react-redux";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { RootState } from "redux/rootReducer";
import { useTranslation } from "react-i18next";

const OrganizationalStructure = () => {
  const { t } = useTranslation();

  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  return (
    <>
      <Header />

      <main className="relative">
        {/* Quick donate */}
        <QuickDonate />

        {/* quick donate popup  */}
        {quickDonateStatus && <QuickDonatePopUp />}

        <MainTitle title={t("Organizational Structure")} />

        <section
          data-aos="fade-up"
          data-aos-duration="900"
          className="my-[50px] w-full h-full px-[20px] lg:px-0"
        >
          <div className="mainContainer w-full h-full flex items-center justify-center">
            <img src="images/structure.png" alt="" />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default OrganizationalStructure;
